import api from './config';

const authHeaders = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        throw new Error('No authentication token found');
    }
    return { Authorization: `Bearer ${atob(token)}` };
};

const toError = (error) => ({
    message: error.response?.data?.message || error.message || 'Something went wrong',
    status: error.response?.status,
});

export const getMindMaps = async () => {
    try {
        const response = await api.get('/mindmap', { headers: authHeaders() });
        return response.data;
    } catch (error) {
        throw toError(error);
    }
};

export const createMindMap = async (title) => {
    try {
        const response = await api.post('/mindmap', { title }, { headers: authHeaders() });
        return response.data;
    } catch (error) {
        throw toError(error);
    }
};

export const getMindMap = async (mindMapId) => {
    try {
        const response = await api.get(`/mindmap/${mindMapId}`, { headers: authHeaders() });
        return response.data;
    } catch (error) {
        throw toError(error);
    }
};

export const saveMindMap = async (mindMapId, { title, version, nodes, shapes }) => {
    try {
        const response = await api.put(`/mindmap/${mindMapId}`, { title, version, nodes, shapes }, { headers: authHeaders() });
        return response.data;
    } catch (error) {
        throw toError(error);
    }
};

export const deleteMindMap = async (mindMapId) => {
    try {
        await api.delete(`/mindmap/${mindMapId}`, { headers: authHeaders() });
    } catch (error) {
        throw toError(error);
    }
};
